var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInputEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 981,
    height: 767,
    viewBox: "0 0 981 767",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M894.7 0H85.2C38.2 0 0 38.1 0 85.2V681.7C0 728.7 38.1 767 85.2 767H894.8C941.8 767 980.1 728.8 980.1 681.7V85.3C979.9 38.2 941.7 0 894.7 0ZM937.4 681.8C937.4 705.3 918.3 724.4 894.8 724.4H85.2C61.7 724.4 42.7 705.3 42.7 681.8V85.3C42.7 61.8 61.7 42.8 85.2 42.8H894.8C918.3 42.8 937.4 61.8 937.4 85.3V681.8ZM264.7 458.3L109.8 613.2C100.8 622.3 100.8 637 109.8 646.1C118.9 655.2 133.7 655.2 142.8 646.1L297.7 491.3C306.8 482.2 306.8 467.5 297.7 458.4C288.6 449.2 273.8 449.2 264.7 458.3ZM841.4 120.1L522.6 440C504.4 458.2 475 458.2 456.7 440L150 133.3V133.4L142.2 125.6C133.1 116.5 118.4 116.5 109.3 125.6C100.2 134.7 100.2 149.5 109.3 158.7L188.4 237.9C188.5 237.9 188.6 238 188.6 238L423.6 473.1C460 509.4 519.1 509.4 555.6 473.1L875.5 154.5C885 145 885 129.8 875.5 120.2C866.2 110.6 850.8 110.6 841.4 120.1ZM708.6 450.5C699 441 683.6 441 674.1 450.5C664.5 460 664.5 475.4 674.1 484.9L834.9 645.9C844.4 655.4 859.8 655.4 869.4 645.9C878.9 636.3 878.9 620.9 869.4 611.4L708.6 450.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputEmail);
export default __webpack_public_path__ + "static/media/inputEmail.9179fd58b07e297e8215c98e739370cb.svg";
export { ForwardRef as ReactComponent };